import { motion } from "framer-motion";
import { ArrowUpRight, Instagram, Music2 } from "lucide-react";
import { INSTAGRAM_URL, TIKTOK_URL } from "@/constants/social";

const channels = [
  {
    name: "Instagram",
    handle: "@vyora.evt",
    description: "Event-Ankündigungen, Visual Drops und Behind-the-Scenes aus dem Vyora Pilot.",
    url: INSTAGRAM_URL,
    icon: Instagram,
    testId: "instagram-profile-link",
  },
  {
    name: "TikTok",
    handle: "@vyoraevents2026",
    description: "Kurze Clips, Countdowns und erste Einblicke in das Pilot Event am 03.10.2026.",
    url: TIKTOK_URL,
    icon: Music2,
    testId: "tiktok-profile-link",
  },
];

export const SocialFeed = () => (
  <section className="px-5 py-24 sm:px-8">
    <div className="mx-auto max-w-7xl">
      <div className="mb-12 max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.24em] text-[#E5C378]">Social Signals</p>
        <h2 className="mt-4 font-syne text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">Alle Vyora-Updates an einem Ort.</h2>
        <p className="mt-5 text-base leading-relaxed text-zinc-400">Folge den offiziellen Kanälen für jeden neuen Drop rund um das erste Pilot Event.</p>
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        {channels.map((channel, index) => {
          const Icon = channel.icon;
          return (
            <motion.a
              key={channel.name}
              data-testid={channel.testId}
              href={channel.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#13131A] p-8 transition-colors duration-300 hover:border-[#E5C378]/40"
            >
              <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#E5C378]/10 blur-3xl transition-opacity duration-300 group-hover:opacity-100" />
              <div className="relative flex items-start justify-between gap-6">
                <div className="grid h-14 w-14 place-items-center rounded-2xl border border-[#E5C378]/25 bg-[#E5C378]/10 text-[#E5C378]">
                  <Icon className="h-6 w-6" />
                </div>
                <ArrowUpRight className="h-6 w-6 text-zinc-500 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#E5C378]" />
              </div>
              <h3 className="relative mt-10 font-syne text-3xl font-bold text-white">{channel.name}</h3>
              <p className="relative mt-2 font-mono text-sm text-[#E5C378]">{channel.handle}</p>
              <p className="relative mt-5 max-w-md text-base leading-relaxed text-zinc-400">{channel.description}</p>
              <span className="relative mt-8 inline-flex rounded-full border border-[#E5C378]/25 px-5 py-3 text-sm font-bold text-[#E5C378]">Profil öffnen</span>
            </motion.a>
          );
        })}
      </div>
    </div>
  </section>
);
